let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("k6H7B")).then(() => parcelRequire('2YaGf'));